import { render } from "./search-group.vue?vue&type=template&id=6a1bd3e6"
import script from "./search-group.vue?vue&type=script&lang=js"
export * from "./search-group.vue?vue&type=script&lang=js"

import "./search-group.vue?vue&type=style&index=0&id=6a1bd3e6&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-hero/template2/search-group.vue'],['render',render],['__file',"search-group.vue"]])

export default __exports__